<template>
  <path
    d="M12 12.0002C14.21 12.0002 16 10.2102 16 8.00024C16 5.79024 14.21 4.00024 12 4.00024C9.79 4.00024 8 5.79024 8 8.00024C8 10.2102 9.79 12.0002 12 12.0002ZM12 14.0002C9.33 14.0002 4 15.3402 4 18.0002V19.0002C4 19.5502 4.45 20.0002 5 20.0002H19C19.55 20.0002 20 19.5502 20 19.0002V18.0002C20 15.3402 14.67 14.0002 12 14.0002Z"
  />
</template>
